import { MDCTextFieldHelperText } from '@material/textfield/helper-text';
import { MDCSelectHelperText } from '@material/select/helper-text';
import { MDCSelect } from '@material/select';
import { MDCTextField } from '@material/textfield';
import { MDCCheckbox } from '@material/checkbox';
import { MDCFormField } from '@material/form-field';
import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';

export const buildForm = function(el) {

    el.querySelectorAll('.mdc-button').forEach(s => {
        s.MDCRipple = new MDCRipple(s);
    })

    el.querySelectorAll('.mdc-select').forEach(s => {
        s.MDCSelect = new MDCSelect(s);
        s.MDCSelect.listen('MDCSelect:change', e => {
            const input = s.querySelector('input[type=hidden]');
            input.value = e.detail.value;
            s.MDCSelect.valid = true;
            input.dispatchEvent(new Event('change'));
            // console.log(select, select.valid)
        });
    })

    el.querySelectorAll('.mdc-text-field').forEach(t => {
        t.MDCTextField = new MDCTextField(t);
    })

    el.querySelectorAll('.mdc-text-field-helper-text').forEach(t => {
        t.MDCTextFieldHelperText = new MDCTextFieldHelperText(t);
    })

    el.querySelectorAll('.mdc-select-helper-text').forEach(t => {
        t.MDCSelectHelperText = new MDCSelectHelperText(t);
    })

    el.querySelectorAll('.mdc-checkbox').forEach(t => {
        t.MDCCheckbox = new MDCCheckbox(t);
    })

    el.querySelectorAll('.mdc-form-field').forEach(t => {
        t.MDCFormField = new MDCFormField(t);
    })

    el.querySelectorAll('.mdc-list').forEach(t => {
        t.MDCList = new MDCList(t);
        t.MDCList.listElements.map(listItemEl => new MDCRipple(listItemEl));

        t.MDCList.listen('MDCList:action', e => {
            if (t.MDCList.foundation_.adapter_.hasCheckboxAtIndex(e.detail.index)) {
                let checkbox = $(t).children().eq(e.detail.index).find("input[type=checkbox]");
                console.log("TRIGGER CHECKBOX CLICK", checkbox.get(0))
                checkbox.triggerHandler('click');
            }
        })
    })

    // ROLLOVER MENU
    el.querySelectorAll('.rollover-menu').forEach(t => {
        t.RolloverMenu = new RolloverMenu(t);
    });
}